import { postV2ApiCompanyIdApprovalWorkflows } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdApprovalWorkflowsResponseOK } from 'src/client/spendesk-api-types';

type CreationPayload = { approvalSchemeId: string };

export const createApprovalWorkflow = async (
  { approvalSchemeId }: CreationPayload,
  companyId: string,
): Promise<PostV2ApiCompanyIdApprovalWorkflowsResponseOK> => {
  const { statusCode, body } = await postV2ApiCompanyIdApprovalWorkflows({
    body: { outcome: { approvalSchemeId }, values: null },
    path: { companyId },
  });
  if (statusCode === 200) {
    return body;
  }
  throw new Error('Impossible to create an approval scheme');
};
